<template>
    <div class="d-flex align-center justify-space-between">
        <v-tooltip
            :max-width="300">
            <template v-slot:activator="{ on }">
                <v-btn
                    class="ml-1"
                    icon
                    v-on="on"
                    type="button"
                    :disabled="isRefreshing"
                    @click="onRefresh">
                    <v-progress-circular
                        v-if="isRefreshing"
                        indeterminate
                       >
                    </v-progress-circular>
                    <v-icon v-else>mdi-refresh-circle</v-icon>
                </v-btn>
            </template>
            <span>This button will refresh carrier and services.</span>
        </v-tooltip>
        <v-row no-gutters>
            <v-col>
                <v-select
                    v-model="selected_carrier"
                    :items="carrierOptions"
                    @change="onSelectCarrier($event)"
                    item-value="id"
                    item-text="name"
                    label="Select Carrier"
                    outlined
                    dense
                    hide-details
                    class="mr-2"
                    :disabled="isLoading || isRefreshing"
                >
                    <template v-slot:item="{ item }">
                        <span :title="item.id">{{ item.name }}</span>
                    </template>
                </v-select>
            </v-col>
            <v-col>
                <v-select
                    v-model="selected_service"
                    :items="servicesOptions"
                    label="Select Carrier Service"
                    outlined
                    dense
                    hide-details
                    class="mr-2"
                    :disabled="isLoading || isRefreshing || servicesOptions.length === 0"
                >
                    <template v-slot:item="{ item }">
                        <span :title="item.value">{{ item.text }}</span>
                    </template>
                </v-select>
            </v-col>
        </v-row>
        <slot
            name="additional-actions"
            :isLoading="isLoading"
            :isRefreshing="isRefreshing"
            :disableAddBtn="disableAddBtn" />
    </div>
</template>

<script>
import { EventBus } from '@/js/event-bus.js'
export default {

    props: {
        integration_id: {
            type: Number,
            required: true
        }
    },

    data() {
        return {
            isLoading: false,
            isRefreshing: false,
            shippingOptionCarrier: null,
            carriers: [],
            carrierOptions: [],
            servicesOptions: [],
            selected_carrier: "",
            selected_service: 0,
            disableAddBtn: true,
        };
    },

    computed: {
        selectedCarrier() {
            const carrier = this.carrierOptions.find(c => c.id == this.selected_carrier) || {};
            return {
                id: carrier.id || "",
                name: carrier.name || 'Select Carriers',
            };
        },
        selectedService() {
            const service = this.servicesOptions.find(s => s.value == this.selected_service) || {};
            return {
                id: service.value || 0,
                name: service.text || 'All Services',
            };
        }
    },

    created() {
        this.initialize();
    },

    methods: {
        initialize() {

            this.isLoading = true;

            this.fetchCarriersFromMachShip();

        },

        fetchCarriersFromMachShip() {
            this.$http
                .get(`/api/machship/carriers?integration_id=${this.integration_id}`)
                .then(({ data }) => {
                    this.carrierOptions = data.result ?? [];
                    this.carrierOptions.unshift(
                        {
                            id: "",
                            name: "Select Carriers",
                            disabled: true
                        },
                        {
                            id: "0",
                            name: "All Carriers"
                        }
                    );
                })
                .catch(err => {
                    EventBus.$emit('show-error', err);
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },

        onSelectCarrier(carrierId) {

            // get the selected carrier
            const selectedCarrier = this.carrierOptions.find(carrier => carrier.id == carrierId);

            const carrierAccounts = selectedCarrier.carrierAccounts ?? [];
            let tempServices = [];

            carrierAccounts.forEach(account => {

                let tempAccServices = account.carrierServices
                    .filter(cservice => !/hourly/i.test(cservice.displayName))
                    .map(cservice => ({
                    value: cservice.id,
                    text: cservice.displayName
                }))
                // collect all services from multi array and append them to our temp variable
                tempServices = [...tempServices, ...tempAccServices];
            });

            tempServices.sort((a, b) => a.text - b.text ); // sort them by name

            this.servicesOptions = tempServices;
            this.servicesOptions.unshift({
                value: 0,
                text: "All Services"
            });

            this.disableAddBtn = false;

        },

        async onRefresh() {

            this.isRefreshing = true

            await this.$http.post('/api/machship/refresh', { integration_id : this.integration_id })
                .then(({ data }) => {
                    this.fetchCarriersFromMachShip()
                    EventBus.$emit('show-success', "Carrier and service refreshed successfully")
                })
                .catch(err => {
                    EventBus.$emit('show-error', err);
                })
                .finally(() => {
                    this.isRefreshing = false
                });
        },

    },

    watch: {
        carrierOptions(newVal) {
            if (this.shippingOptionCarrier) {
                this.selected_carrier = this.shippingOptionCarrier.carrier_id;
                if(this.selected_carrier == "0"){
                    this.selected_carrier = this.selected_carrier.toString();
                }
                this.selected_service = this.shippingOptionCarrier.service_id;
                this.onSelectCarrier(this.shippingOptionCarrier.carrier_id);
            }
        },

        selected_carrier(newVal) {
            this.disableAddBtn = newVal === "";
        }
    }

}
</script>